import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchTiposPublicacionAdm, setTiposPublicacion, resetSetTiposPublicaciones } from '../../../actions/tiposPublicacionActions';
import { fetchTiposPublicacion } from '../../../actions/publicacionesActions';
import { setObject } from '../../../actions/generalActios';
import SafeReactPaginate from '../../General/SafeReactPaginate';
import GoBackArrow from '../../General/GoBackArrow';
import BigSpinner from '../../General/BigSpinner';
import { withNavigation } from '../../General/withNavigation';
import { selectSellerMerged } from '../../../helper/sellerMergedSelector';
import { editSeller } from '../../../actions/sellersActions';
import PropTypes from 'prop-types';
import { formatoDecimal } from '../../../utilities/formatoNumeros';

// Wrapper para usar hooks en class component
function SelectTipoPublicacionesWrapper(props) {
    const navigate = useNavigate();
    return <SelectTipoPublicaciones {...props} navigate={navigate} />;
}

class SelectTipoPublicaciones extends React.Component {
    constructor() {
        super();
        this.state = {
            didEdit: false,
            checked: 0,
            listaIdTiposPublicaciones: [],
            pageSize: 10,
            page: 1
        }
    }

    componentDidMount() {
        if (!this.props.editando) {
            this.props.setTiposPublicacion([]);
        }

        // this.props.fetchTiposPublicacion(this.props.seller.codigo);
        this.busquedaTiposPublicacion();
    }

    busquedaTiposPublicacion = async (numPagina) => {
        await this.props.fetchTiposPublicacionAdm({
            idSeller: null,
            Page: numPagina ?? 1,
            PageSize: 10,
            Estado: 0,
        });

        this.comprobarCheckbox();
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        this.setState({ page: selectedPage });
        this.busquedaTiposPublicacion(selectedPage);
    }

    changeCheck = (params) => {
        this.addToAsociarSeller(params);
    }

    clickFila = (params) => {
        this.addToAsociarSeller(params);
    }

    codigoTipoItem = (item) =>
        item?.codigo ?? item?.idTipoPublicacion ?? item?.IdTipoPublicacion ?? "";

    addToAsociarSeller = (params) => {
        let arrayEstado = [];
        arrayEstado = this.state.listaIdTiposPublicaciones;
        const pid = this.codigoTipoItem(params);
        let repetido = arrayEstado.some(item => this.codigoTipoItem(item) == pid);

        if (repetido) {
            let index = arrayEstado.findIndex(x => this.codigoTipoItem(x) == pid);
            if (index !== undefined) {
                arrayEstado.splice(index, 1);
                this.setState({ listaIdTiposPublicaciones: arrayEstado });
                this.props.setTiposPublicacion(arrayEstado);
                const el = document.getElementById("check" + pid);
                if (el) el.checked = false;
            }
        }
        else {
            arrayEstado.push(params);
            this.setState({ listaIdTiposPublicaciones: arrayEstado });
            this.props.setTiposPublicacion(arrayEstado);
            const el = document.getElementById("check" + pid);
            if (el) el.checked = true;
        }
    }

    comprobarCheckbox = () => {
        setTimeout(() => {
            let planChecked = [];
            let plan = [];
            let idsIniciales = [];

            if (Array.isArray(this.props.settedTiposPublicacion) && this.props.settedTiposPublicacion.length > 0) {
                for (let i = 0; i < this.props.settedTiposPublicacion.length; i++) {
                    const cid = this.codigoTipoItem(this.props.settedTiposPublicacion[i]);
                    planChecked.push("check" + cid);
                    idsIniciales.push(this.props.settedTiposPublicacion[i]);
                }
            } else {
                const asignados = this.props.tiposPublicacionesAsignados || [];
                for (let i = 0; i < asignados.length; i++) {
                    const cid = this.codigoTipoItem(asignados[i]);
                    planChecked.push("check" + cid);
                    idsIniciales.push(asignados[i]);
                }
            }

            this.setState({
                listaIdTiposPublicaciones: idsIniciales
            });

            const inputs = document.getElementsByName('checkBoxes');
            for (let i = 0; i < inputs.length; i++) {
                plan.push(inputs[i].id);
            }
            for (let i = 0; i < plan.length; i++) {
                const inp = document.getElementById(plan[i]);
                if (inp) inp.checked = false;
            }
            for (let i = 0; i < planChecked.length; i++) {
                for (let c = 0; c < plan.length; c++) {
                    if (plan[c] === planChecked[i]) {
                        const inp = document.getElementById(plan[c]);
                        if (inp) inp.checked = true;
                    }
                }
            }
        }, 500);
    }

    agregarTiposASeller = () => {
        this.props.setObject(this.props.seller);

        if (this.props.editando) {
            this.props.navigate(`/Sellers/Editar/Select/${this.props.seller.codigo}`, { state: 2 });
        } else {
            this.props.navigate("/Sellers/Nuevo/Select", { state: 2 });
        }
    }

    onBack = () => {
        this.props.resetSetTiposPublicaciones();

        const sellerId = this.props.seller?.codigo;

        if (this.props.editando && sellerId != null) {
            this.props.navigate(`/Sellers/Editar/${sellerId}`, { state: 2 });
            return;
        }

        this.props.navigate("/Sellers/Nuevo", { state: 2 });
    }


    render() {
        let elements = null;
        if (this.props.tiposPublicaciones != undefined) {
            elements = this.props.tiposPublicaciones
                .filter(item => item.estado === 0)
                .map((item, i) => {
                    const idTipo = this.codigoTipoItem(item);
                    return (
                        <div
                            key={i}
                            role="button"
                            tabIndex={0}
                            onClick={() => this.clickFila(item)}
                            onKeyDown={(e) => e.key === 'Enter' && this.clickFila(item)}
                            className="admin-list-card p-3 admin-list-card--vigente mb-2"
                        >
                            <div className="row g-2 g-md-3 align-items-center justify-content-between">
                                <div className="col-auto" onClick={(e) => e.stopPropagation()}>
                                    <span className="admin-id-badge">{idTipo}</span>
                                </div>
                                <div className="col-12 col-md-4 col-lg-5 text-break">
                                    <div className="admin-list-card__title fw-semibold small mb-0">{item.descripcion}</div>
                                </div>
                                <div className="col-6 col-md-auto d-flex justify-content-md-end">
                                    <span className="admin-metric-pill">
                                        {formatoDecimal(item.comision)}
                                        <i className="fas fa-percent" aria-hidden="true" />
                                    </span>
                                </div>
                                <div className="col-6 col-md-auto d-flex justify-content-end" onClick={(e) => e.stopPropagation()}>
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            onClick={() => this.clickFila(item)}
                                            name="checkBoxes"
                                            onChange={() => this.changeCheck(item)}
                                            type="checkbox"
                                            className="custom-control-input"
                                            id={"check" + idTipo}
                                        />
                                        <label className="custom-control-label" htmlFor={"check" + idTipo} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                });
        }


        return (
            <div className="container">
                <div className="row align-items-center justify-content-between page-titles admin-page-heading mb-3">
                    <div className="col-12 col-sm-8">
                        <h3 className="text-themecolor color-rojo-megatone mb-0">Tipo de publicación</h3>
                        <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">
                            Seleccioná los tipos a asociar al seller (misma vista que en administración).
                        </p>
                    </div>
                </div>

                <div className="row justify-content-between align-items-center">

                    <div className="col-auto mb-3">
                        <GoBackArrow onBack={this.onBack} />
                    </div>

                    <div className="col-auto text-end mb-3">
                        <button
                            onClick={() => this.agregarTiposASeller()}
                            className="btn btn-sm background-rojo-megatone waves-light"
                        >
                            Agregar/Quitar
                        </button>
                    </div>

                    <div hidden={!this.props.loadingTipoPublicaciones}>
                        <BigSpinner message="Cargando tipos de publicacion..." />
                    </div>

                    <div
                        className="col-12 animated fadeIn"
                        hidden={this.props.loadingTipoPublicaciones}
                    >
                        <div className="admin-list-stack">
                            {elements}
                        </div>
                    </div>

                    <div className="d-flex justify-content-center">

                        <SafeReactPaginate
                            previousLabel={"Anterior"}
                            nextLabel={"Siguiente"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={Math.ceil(this.props.cantidadTotal / this.state.pageSize)}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={5}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={this.state.page - 1}
                        />
                    </div>

                </div>
            </div>
        );
    }
}
SelectTipoPublicaciones.propTypes = {
    // Hooks props
    navigate: PropTypes.func,
    location: PropTypes.shape({
        pathname: PropTypes.string,
    }),
    // Redux props
    settedTiposPublicacion: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.shape({
        codigo: PropTypes.string,
    }))]),
    tiposPublicaciones: PropTypes.arrayOf(PropTypes.shape({
        codigo: PropTypes.string,
        comision: PropTypes.number,
        descripcion: PropTypes.string,
        estado: PropTypes.number,
    })),
    seller: PropTypes.shape({
        codigo: PropTypes.string,
    }),
    loadingTipoPublicaciones: PropTypes.bool,
    cantidadTotal: PropTypes.number,
    // Actions props
    fetchTiposPublicacionAdm: PropTypes.func,
    setTiposPublicacion: PropTypes.func,
    resetSetTiposPublicaciones: PropTypes.func,
    setObject: PropTypes.func,
    editando: PropTypes.bool,
}


const mapStateToProps = state => ({
    seller: selectSellerMerged(state),
    editando: state.general.editando,
    idSeller: state.general.idSeller,
    tipoUsuario: state.general.tipoUsuario,
    loadingTipoPublicaciones: state.tiposPublicacion.loadingTiposPublicacion,
    tiposPublicaciones: state.tiposPublicacion.tiposPublicaciones.elementos,
    /** Desde publicaciones o, si viene de edición de seller, desde tiposPublicacion.setTiposPublicacion */
    tiposPublicacionesAsignados: (() => {
        const pub = state.publicaciones?.tiposPublicacion;
        const set = state.tiposPublicacion?.setTiposPublicacion;
        if (Array.isArray(set) && set.length > 0) return set;
        return Array.isArray(pub) ? pub : [];
    })(),
    settedTiposPublicacion: state.tiposPublicacion.setTiposPublicacion,

    cantidadTotal: state.tiposPublicacion.tiposPublicaciones.total,
    numeroPagina: state.tiposPublicacion.tiposPublicaciones.page,
});

export default withNavigation(connect(mapStateToProps, {
    fetchTiposPublicacionAdm,
    fetchTiposPublicacion,
    setTiposPublicacion,
    resetSetTiposPublicaciones,
    setObject,
    editSeller,
})(SelectTipoPublicacionesWrapper));